import { Button } from '@egw/components'
import { Trans, useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { ExclamationCircleIcon } from '@heroicons/react/24/outline'
import { ClientServicesLink } from '..'

export enum JointAcatTransferConfirmType {
  NA = 'NA',
  ERROR = 'ERROR',
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
}

export interface JointAcatTransferConfirmModalProps {
  isLoading: boolean
  onConfirm: () => void
  onCancel: () => void
  confirmType: JointAcatTransferConfirmType
  showError: boolean
}

export const JointAcatTransferConfirmation: FC<JointAcatTransferConfirmModalProps> = ({
  isLoading,
  onConfirm,
  onCancel,
  confirmType,
  showError,
}) => {
  const { t } = useTranslation('features-transfer')
  return (
    <div className="flex flex-col">
      {showError ? (
        <p className="w-full flex flex-col gap-4">
          <ExclamationCircleIcon className="h-[4rem] w-[4rem] text-alert-300" />
          <h1 className="typo-primary-xl-light text-text-header-error">{t('joint_acat.transfer_error')}</h1>
          <Trans t={t} i18nKey={`joint_acat.error.${confirmType}.description`}>
            <ClientServicesLink onClickCb={onCancel} />
          </Trans>
        </p>
      ) : (
        <>
          <p className="typo-primar-base-regular text-text-body">
            {confirmType === JointAcatTransferConfirmType.ACCEPT
              ? t('joint_acat.confirm_authorization_description')
              : t('joint_acat.reject_authorization_description')}
          </p>
          <div className="my-lg flex flex-col gap-xs">
            <Button
              data-testid="join-acat-transfer-confirm-modal-button"
              onClick={onConfirm}
              isLoading={isLoading}
              variant="primary"
              size="small"
              className="w-full"
            >
              {confirmType === JointAcatTransferConfirmType.ACCEPT
                ? t('joint_acat.confirm_cta')
                : t('joint_acat.reject_cta')}
            </Button>
            <Button
              data-testid="join-acat-transfer-back-modal-button"
              onClick={onCancel}
              variant="secondary"
              size="small"
              className="w-full"
            >
              {t('joint_acat.back')}
            </Button>
          </div>
        </>
      )}
    </div>
  )
}
